import {type VariantProps, tv} from 'tailwind-variants'
import {cn} from '~/design-system/utils'

export type HgArticleHeroTextProps = {
  tagText: string
  heading: React.ReactNode
  subheading: React.ReactNode
  level: NonNullable<VariantProps<typeof hgArticleHeroTextVariants>['level']>
  classNames?: {
    container?: string
    tag?: string
    heading?: string
    subheading?: string
  }
}

const hgArticleHeroTextVariants = tv({
  variants: {
    level: {
      high: 'tiempos-display-3',
      medium: 'tiempos-display-4',
      low: 'tiempos-heading-1',
    },
  },
})

export default function HgArticleHeroText({
  tagText,
  heading,
  subheading,
  level,
  classNames,
}: HgArticleHeroTextProps) {
  return (
    <div
      className={cn(
        classNames?.container,
        'flex flex-col gap-s2 text-center text-text-default'
      )}
    >
      <span className={cn(classNames?.tag, 'arcadia-ui-4')}>{tagText}</span>
      <h1
        className={hgArticleHeroTextVariants({
          level,
          className: classNames?.heading,
        })}
      >
        {heading}
      </h1>
      <div className={cn(classNames?.subheading, 'tiempos-heading-7')}>
        {subheading}
      </div>
    </div>
  )
}
